export const PIZZAS_REQUEST: "PIZZAS_REQUEST" = "PIZZAS_REQUEST";
export const PIZZAS_REQUEST_SUCCESS: "PIZZAS_REQUEST_SUCCESS" = "PIZZAS_REQUEST_SUCCESS";
export const PIZZAS_REQUEST_ERROR: "PIZZAS_REQUEST_ERROR" = "PIZZAS_REQUEST_ERROR";
